import React from "react"

import { Row, Col } from "reactstrap"
import Proptypes from "prop-types"

import Img from "../../../../images/services/consultation/servicegrid1.png"
import Img2 from "../../../../images/services/consultation/servicegrid2.png"

const ServiceExperiance = props => {
  return (
    <div>
      {props.righttxt1 ? (
        <div className="partnership-pricing">
          <Row>
            <Col md="6" style={{ paddingRight: 0, paddingLeft: "2vw" }}>
              <div className="text-wrapper">
                <div className="description medium-font">
                  {props.righttxt1}
                  <br /> {props.righttxt2}
                  <br /> {props.righttxt3}
                  <br /> {props.righttxt4}
                  <br /> {props.righttxt5}
                  <br />
                  {props.righttxt6}
                  <br /> {props.righttxt7}
                  <br />
                  {props.righttxt8}
                  <br /> {props.righttxt9}
                </div>
              </div>
            </Col>
            <Col md="6" className="image-wrapper">
              <img
                src={Img}
                alt="Meetrix.IO is your technology partner for Jitsi Meet implementation"
              />
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
      {props.lefttxt1 ? (
        <div className="partnership-pricing2">
          <Row>
            <Col md="6" className="image-wrapper">
              <img
                src={Img2}
                alt="Meetrix.IO is your technology partner for Jitsi Meet implementation"
              />
            </Col>
            <Col md="6" style={{ paddingRight: 0, paddingLeft: 0 }}>
              <div className="text-wrapper">
                <div className="description medium-font">
                  {props.lefttxt1}
                  <br /> {props.lefttxt2}
                  <br /> {props.lefttxt3}
                  <br /> {props.lefttxt4}
                  <br /> {props.lefttxt5}
                  <br />
                  {props.lefttxt6}
                  <br /> {props.lefttxt7}
                  <br />
                  {props.lefttxt8}
                  <br /> {props.lefttxt9}
                  <br /> {props.lefttxt10}
                  <br /> {props.lefttxt11}
                  <br /> {props.lefttxt12}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}
ServiceExperiance.prototype = {
  righttxt1: Proptypes.any,
  righttxt2: Proptypes.any,
  righttxt3: Proptypes.any,
  righttxt4: Proptypes.any,
  righttxt5: Proptypes.any,
  righttxt6: Proptypes.any,
  righttxt7: Proptypes.any,
  righttxt8: Proptypes.any,
  righttxt9: Proptypes.any,

  lefttxt1: Proptypes.any,
  lefttxt2: Proptypes.any,
  lefttxt3: Proptypes.any,
  lefttxt4: Proptypes.any,
  lefttxt5: Proptypes.any,
  lefttxt6: Proptypes.any,
  lefttxt7: Proptypes.any,
  lefttxt8: Proptypes.any,
  lefttxt9: Proptypes.any,
  lefttxt10: Proptypes.any,
  lefttxt11: Proptypes.any,
  lefttxt12: Proptypes.any,
}
export default ServiceExperiance
